import { rootEpics$ } from 'store/epicMiddleware';
import { ProfileActionsType } from '../interfaces';
import { profileEpics } from './referral.duck';

// Idempotent guard to avoid double registration of referral epics.
// On some menu navigations the profile router may mount/effect twice,
// which would otherwise register epics twice and duplicate network requests.
// The flag is reset in `unregisterProfileModule()` when leaving referral pages.
let isProfileModuleRegistered = false;

export const registerProfileModule = () => {
  if (isProfileModuleRegistered) return;
  rootEpics$.next([profileEpics, ProfileActionsType.PROFILE_DETACH_LISTENERS]);
  isProfileModuleRegistered = true;
};

export const unregisterProfileModule = () => {
  // Actual detach is triggered by dispatching PROFILE_DETACH_LISTENERS in the router.
  // Here we only flip the guard so the next entry can re-register epics once.
  isProfileModuleRegistered = false;
};
